/**
 * Errors nobody caught (a throw in a callback, a rejected promise) are listed in a small banner at the
 * top of the page, outside the canvas, so a re-render can never hide them. The kiosk keeps running.
 */
import { useEffect, useState } from 'react';
import { describeError, diagnosticsStore, report } from '../core/diagnostics';
import { useStore } from '../react/useStore';
import css from './CrashBanner.module.css';

export function installGlobalErrorHandlers(): void {
  window.addEventListener('error', (e) => report('error', 'window', e.message || describeError(e.error), e.error?.stack));
  window.addEventListener('unhandledrejection', (e) => report('error', 'promise', describeError(e.reason), (e.reason as Error | undefined)?.stack));
}

export function CrashBanner() {
  const errors = useStore(diagnosticsStore, (d) => d.filter((x) => x.level === 'error'));
  const [dismissed, setDismissed] = useState(0);
  const visible = errors.filter((e) => e.id > dismissed);
  useEffect(() => {
    if (visible.length === 0) return;
    const last = visible.at(-1)!.id;
    const id = setTimeout(() => setDismissed(last), 20_000); // the totem clears it by itself
    return () => clearTimeout(id);
  }, [visible]);
  if (visible.length === 0) return null;
  return (
    <div className={css.banner} role="alert">
      <ul>
        {visible.slice(-3).map((e) => <li key={e.id}><b>{e.source}</b> {e.message}</li>)}
      </ul>
      <button onClick={() => setDismissed(visible.at(-1)!.id)}>×</button>
    </div>
  );
}
